module.exports = __webpack_public_path__ + "img/american-express.a38fdb50.svg";